import { I as Icon, _ as __assign } from './loadable.esm-c9931684.js';
import React from 'react';
import 'styled-components';

var RegionIcon = function (props) { return (React.createElement(Icon, __assign({}, props, { viewBox: "0 0 46 46" }),
    React.createElement("path", { d: "M31.57 32.512a85.848 85.848 0 01-1.493 1.851C38.13 35.212 43 37.391 43 39c0 2.039-7.791 5-20 5S3 41.039 3 39c0-1.609 4.87-3.788 12.923-4.637a88.376 88.376 0 01-1.493-1.851C6.949 33.442 1 35.631 1 39c0 4.596 11.067 7 22 7s22-2.404 22-7c0-3.369-5.949-5.558-13.43-6.488z" }),
    React.createElement("path", { d: "M23 0C15.627 0 8 5.611 8 15c0 8.95 13.707 22.866 14.29 23.455a1 1 0 001.42 0C24.293 37.866 38 23.95 38 15c0-9.389-7.627-15-15-15zm0 20c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5z" }))); };

export default RegionIcon;
